import {Injectable} from "@angular/core";
import {BaseService} from "../base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {catchError, tap} from "rxjs/operators";
import {WhCategoriesModel} from "../../models/categories/wh-categories.model";

@Injectable()
export class CategoriesService extends BaseService<any>{
  constructor(public httpClient: HttpClient) {
    super(
      'categories',
      httpClient);
  }

  getCategories(): Observable<WhCategoriesModel[]> {
    return this.httpClient.get<WhCategoriesModel[]>(new URL(environment.baseUrl + '/categories').toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }

}
